


















import { Component, Prop, Vue } from 'vue-property-decorator';
import Container from '@/components/Container.vue';

@Component({
  components: {
    Container
  }
})
export default class PageInProgress extends Vue {
  @Prop(String) subtitleText!: string;
  defaultSubtitleText: string =
    'This page is under construction. Please check back later.';

  get subtitle() {
    if (this.subtitleText) {
      return this.subtitleText;
    }
    return this.defaultSubtitleText;
  }
}
